import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useRef, useState, useContext } from "react";
import { toast } from "react-toastify";
import { otpVerifyEmailHandler } from "../../service/AuthService";
import { AppContext } from "../../context/AppContext";

export default function TermsAndCondition({
  open,
  setOpen,
  otpCheck,
  email,
  setOtpCheck,
}) {
  const cancelButtonRef = useRef(null);
  const [otp, setOtp] = useState(["", "", "", ""]);
  const { setemailVerification } = useContext(AppContext);

  const handleOtpEmailVerify = async () => {
    const otpNumber = otp.join("");
    if (!otpNumber) {
      toast.error("Please enter your OTP");
      return;
    }
    try {
      const data = await otpVerifyEmailHandler(email, otpNumber);
      console.log(data);
      if (data.header.code === 600) {
        toast.success(data.body.value);
        setOpen(false);
        setOtpCheck(false);
        setemailVerification(true);
      }
    } catch (error) {
      toast.error(error.message || "Something went wrong");
    }
  };

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-6xl">
                <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                  <div className="sm:flex sm:items-start">
                    <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                      <Dialog.Title
                        as="h3"
                        className="text-base text-center font-semibold leading-6 text-gray-900"
                      >
                        {otpCheck ? "" : "Terms and Condition"}
                      </Dialog.Title>
                      <div className="mt-2">
                        {otpCheck ? (
                          <div className="flex items-center gap-5">
                            <div>
                              <img src="https://img.freepik.com/premium-vector/enter-otp-concept-illustration_86047-737.jpg" alt="OTP Verification Illustration" />
                            </div>
                            <div class="my-auto mx-auto flex flex-col justify-center px-6 pt-8 md:justify-start">
                              <p class="text-center text-3xl font-bold md:text-left md:leading-tight">
                                OTP Verification
                              </p>
                              <p class="mt-2 text-center text-gray-500 font-medium md:text-left">
                                Enter your Otp for verify and reset your
                                password.
                              </p>

                              <div class="flex flex-col items-stretch pt-3 md:pt-8">
                                <div class="flex flex-col pt-6">
                                  <div className="flex flex-col space-y-16">
                                    <div className="flex flex-row items-center justify-between mx-auto w-full max-w-sm">
                                      {[1, 2, 3, 4].map((index) => (
                                        <div key={index} className="w-16 h-16 ">
                                          <input
                                            className="w-full h-full flex flex-col items-center justify-center text-center px-5 outline-none rounded-xl border border-gray-400 text-lg bg-white focus:bg-gray-50 focus:ring-1 ring-gray-800"
                                            type="text"
                                            value={otp[index - 1] || ""}
                                            onChange={(e) => {
                                              const updatedOtp = [...otp];
                                              updatedOtp[index - 1] =
                                                e.target.value;
                                              setOtp(updatedOtp);
                                            }}
                                          />
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                </div>

                                <div className="flex items-center justify-between mt-5">
                                  <button
                                    className="mt-6  rounded-lg bg-gray-800 px-4 py-2 text-center text-base font-semibold text-white shadow-md outline-none ring-gray-500 ring-offset-2 transition hover:bg-gray-900 focus:ring-2 md:w-32"
                                    onClick={handleOtpEmailVerify}
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          // General Terms and Condition content
                          // Add your general terms and condition content here
                          <div>
                            <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                              <div className="sm:flex sm:items-start">
                                <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                                  <Dialog.Title
                                    as="h3"
                                    className="text-base text-center font-semibold leading-6 text-gray-900"
                                  >
                                    Terms and Condition
                                  </Dialog.Title>
                                  <div className="mt-2">
                                    <p className="text-sm text-gray-500 leading-6 whitespace-pre-line">
                                      Version 1.0, Effective as of June 1, 2024
                                      {"\n\n"}
                                      These Terms and Conditions (the "Terms") constitute the legal agreement that delineates the relationship between you, the User, and Balarch LLC ("Balarch"), in its role as a provider of digital services and platforms designed for the exhibition and dissemination of architectural projects.
                                      {"\n\n"}
                                      By engaging with this website and Balarch's suite of digital services, you acknowledge and consent to these Terms as a binding component of your contractual relationship with us. This agreement encompasses your commitment to adhere to the terms and legal conditions associated with our offerings, including any third-party services and products we may facilitate.
                                      {"\n\n"}
                                      Certain digital services offered by Balarch may be governed by their own specific Terms of Use, which are clearly indicated within their respective commercial proposals. In the event of any conflict between these general Terms and the specific Terms of Use, the specific Terms shall prevail.
                                      {"\n\n"}
                                      <span className="font-semibold text-gray-900 block mt-4">Intellectual Property Rights and User Submissions</span>
                                      The intellectual property, including trademarks, names, logos, images, photographs, graphics, designs, content, texts (including advertisements), layouts, software, and all other materials featured in our digital services, are owned by Balarch LLC or are utilized under license from third parties. Users are forbidden from reproducing, transmitting, modifying, or using these materials for any public or commercial purpose without explicit prior written consent from Balarch.
                                      {"\n\n"}
                                      Upon submission of architectural projects, including all related media, to Balarch, users grant Balarch an irrevocable, perpetual, non-exclusive, royalty-free, worldwide license to publish, display, modify, distribute, and reproduce the submitted materials in our magazine, online platforms, and books. This license is intended to enable Balarch to showcase and promote the architectural projects submitted by professionals through our services.
                                      {"\n\n"}
                                      <span className="font-semibold text-gray-900 block mt-4">Limitation of Liability</span>
                                      Balarch LLC is committed to delivering high-quality, accurate, and accessible digital offerings but cannot guarantee uninterrupted service or the absence of temporary limitations. User access and engagement with our products are at the user's own risk, with all warranties related to our products and software expressly disclaimed.
                                      {"\n\n"}
                                      Liability for third-party services and content linked from our services is also disclaimed. Balarch does not assume responsibility for the legality, accuracy, completeness, or availability of third-party content, nor for damages caused by malicious software.
                                      {"\n\n"}
                                      Balarch LLC's liability is limited to cases of intentional or gross negligence and is capped at the amount paid by the User for chargeable services. Balarch is not liable for indirect damages or loss of profits.
                                      {"\n\n"}
                                      <span className="font-semibold text-gray-900 block mt-4">General Provisions</span>
                                      Balarch LLC's failure to enforce any rights under these Terms does not constitute a waiver of such rights. Should any term be deemed invalid, the remainder of the Terms shall remain in effect, with the invalid term replaced by an equivalent provision that reflects the original intent.
                                      {"\n\n"}
                                      Balarch reserves the right to amend these Terms at its discretion. Amendments will be published on our digital platforms, with Users responsible for staying informed of current provisions.
                                      {"\n\n"}
                                      <span className="font-semibold text-gray-900 block mt-4">Governing Law and Jurisdiction</span>
                                      Disputes arising from these Terms shall be exclusively resolved in the jurisdiction of the United States, specifically within the state where Balarch LLC is registered, governed by the laws of the United States, excluding conflict of laws principles and the CISG.
                                      {"\n\n"}
                                      By submitting architectural projects to Balarch, Users affirm their understanding and agreement that Balarch has the right to utilize the submitted materials as described, safeguarding Balarch's ability to promote and disseminate architectural works effectively.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                              <button
                                type="button"
                                className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                                onClick={() => setOpen(false)}
                                ref={cancelButtonRef}
                              >
                                Accept
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
